// extracted by mini-css-extract-plugin
export default {"title":"styles_title__wVeXk","value":"styles_value__-MtVn","accordionContainer":"styles_accordionContainer__KVG6O"};